import api from './api';

export const getAccounts = async (skip = 0, limit = 50) => {
  const response = await api.get('/accounts', {
    params: { skip, limit },
  });
  return response.data;
};

export const getAccount = async (accountId) => {
  const response = await api.get(`/accounts/${accountId}`);
  return response.data;
};

export const createAccount = async (accountData) => {
  const response = await api.post('/accounts', accountData);
  return response.data;
};

export const updateAccount = async (accountId, accountData) => {
  const response = await api.put(`/accounts/${accountId}`, accountData);
  return response.data;
};
